import { Directive, ContentChildren, QueryList, ElementRef } from "@angular/core";
import { SuiRadio } from "../components/radio";
import { Util } from "../../../misc/util/index";
import * as ɵngcc0 from '@angular/core';
var SuiRadioManager = /** @class */ (function () {
    function SuiRadioManager(element) {
        this.element = element;
        this.isNested = false;
        this._radioSubs = [];
    }
    SuiRadioManager.prototype.ngAfterContentInit = function () {
        var _this = this;
        this.updateNesting();
        this._subManagers.changes.subscribe(function () { return _this.updateNesting(); });
        this.updateRadios();
        this._renderedRadios.changes.subscribe(function () { return _this.updateRadios(); });
    };
    SuiRadioManager.prototype.updateNesting = function () {
        var _this = this;
        this._subManagers
            .filter(function (m) { return m !== _this; })
            .forEach(function (m) { return m.isNested = true; });
    };
    SuiRadioManager.prototype.updateRadios = function () {
        var _this = this;
        this._radioSubs.forEach(function (s) { return s.unsubscribe(); });
        this._radioSubs = [];
        var groups = Util.Array.groupBy(this._renderedRadios.toArray(), "name");
        Object
            .keys(groups)
            .map(function (k) { return groups[k]; })
            .forEach(function (g) {
            return g
                .forEach(function (r) {
                return _this._radioSubs
                    .push(r.onCurrentValueChange
                    .subscribe(function (v) {
                    if (!_this.isNested) {
                        g.forEach(function (radio) { return radio.writeValue(v); });
                    }
                }));
            });
        });
    };
    /** @nocollapse */
    SuiRadioManager.ctorParameters = function () { return [
        { type: ElementRef, },
    ]; };
    SuiRadioManager.propDecorators = {
        "_subManagers": [{ type: ContentChildren, args: [SuiRadioManager, { descendants: true },] },],
        "_renderedRadios": [{ type: ContentChildren, args: [SuiRadio, { descendants: true },] },],
    };
SuiRadioManager.ɵfac = function SuiRadioManager_Factory(t) { return new (t || SuiRadioManager)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
SuiRadioManager.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: SuiRadioManager, selectors: [["form", 3, "ngForm", "", 3, "ngForm", ""], ["ngForm"], ["", "ngForm", ""]], contentQueries: function SuiRadioManager_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, SuiRadioManager, 5);
        ɵngcc0.ɵɵcontentQuery(dirIndex, SuiRadio, 5);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._subManagers = _t);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._renderedRadios = _t);
    } } });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SuiRadioManager, [{
        type: Directive,
        args: [{
                selector: "form:not([ngForm]):not([[ngForm]]),ngForm,[ngForm]"
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { _subManagers: [{
            type: ContentChildren,
            args: [SuiRadioManager, { descendants: true }]
        }], _renderedRadios: [{
            type: ContentChildren,
            args: [SuiRadio, { descendants: true }]
        }] }); })();
    return SuiRadioManager;
}());
export { SuiRadioManager };

